<template>
  <div>
    <v-card class="card--flex-toolbar" flat>
      <v-tabs
        color="grey lighten-3"
        v-model="currentTab"
        dark
        slider-color="grey darken-4"
      >
        <v-tab
          ripple
          v-for="tab in tabs"
          :key="tab.href"
          :to="{ name: tab.route_name }"
          class="grey--text text--darken-4 caption"
          >{{ tab.text }}</v-tab
        >
      </v-tabs>
    </v-card>
    <v-card v-if="loading" height="50vh">
      <v-content class="content-background">
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </v-card>
    <v-card v-else class="pa-3" flat>
      <v-form v-if="filmMaker" ref="form">
        <v-layout row wrap>
          <v-flex xs4>
            <v-container bg fill-height grid-list-md text-xs-center py-0 pl-0>
              <v-layout fill-height row wrap align-center>
                <v-flex class="pa-0">
                  <v-card fill-height @click="showDropzoneLogoDialog = true">
                    <v-img
                      v-if="filmMaker.profile_url"
                      height="12vmin"
                      contain
                      :src="filmMaker.profile_url"
                    ></v-img>
                    <v-icon
                      color="blue-grey lighten-4"
                      style="font-size: 70px"
                      v-else
                      >mdi-cloud-upload</v-icon
                    >
                    <v-card-title class="justify-center">
                      <v-chip color="primary white--text font-weight-bold"
                        >{{
                          $t(
                            "film.makers.update.page.form.btn.upload.profile.picture"
                          )
                        }}
                      </v-chip>
                    </v-card-title>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
            <SingleFileUploader
              key="upload_profile_picture"
              v-model="showDropzoneLogoDialog"
              :title="$t('screener.company.profile.upload_logo')"
              :warning="$t('screener.admin.drag_and_drop.warning')"
              :attribute="'logo_url'"
              :collection="this.DEFINES.COLLECTION_PUBLIC"
              :model_id="filmMaker.id"
              :model_type="this.DEFINES.MODEL_FILM_MAKER"
              :dropzoneOptions="dropzoneOptions(`filmMaker/${filmMaker.id}/upload`)"
              @setThumbnal="setThumbnail"
              @successUpload="afterThumbnailUpload"
              @onError="showError"
            ></SingleFileUploader>
          </v-flex>
          <v-flex xs8>
            <v-select
              :items="DEFINES.FILMMAKER.TYPES"
              v-model="filmMaker.type"
              :label="$t('film.makers.update.page.form.field.type')"
              outline
              item-value="value"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="mt-5">
          <v-flex xs12>
            <v-card elevation="2">
              <v-card-title>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-tabs
                        background-color="transparent"
                        color="basil"
                        grow
                        v-model="widget_language"
                    >
                      <v-tab
                        v-for="language in enabledLanguages" :key="language.name"
                      >
                        {{ language.text }}
                      </v-tab>
                    </v-tabs>
                  </v-flex>
                  <v-flex xs6>
                    <div style="float: right;" v-if="widget_language === 0">
                      <v-tooltip 
                        bottom
                        max-width="300"
                        color="grey darken-3"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            color="grey lighten-3"
                            class="override-btn"
                            outlined
                            style="float:right"
                            small
                            @click="setFieldLanguageData(['name','short_description','filmography'], filmMaker)"
                          >
                          {{ $t('language_copy_all_button_label') }}
                          </v-btn>
                        </template>
                        <div class="pa-2">
                          <div class="body-2">{{ $t('language_copy_all_button_info') }}</div>
                        </div>
                      </v-tooltip>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-text class="mt-3">
                <v-tabs-items v-model="widget_language">
                  <v-tab-item
                      v-for="language in enabledLanguages"
                      :key="language.name"
                  >
                    <v-flex xs12>
                      <v-text-field
                        v-model="filmMaker.name[language.value]"
                        name="filmmakers_name"
                        :label="$t('film.makers.update.page.form.field.name')"
                        outline
                        :rules="[
                          rules.min_length(3),
                          rules.max_length(250),
                        ]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="filmMaker.short_description[language.value]"
                        name="filmmakers_name"
                        :label="
                          $t('film.makers.update.page.form.field.short_description')
                        "
                        outline
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <!-- Description -->
                      <TextEditor
                        :title="$t('film.makers.update.page.form.field.filmography')"
                        v-model="filmMaker.filmography[language.value]"
                      />
                    </v-flex>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="save()">{{
            $t("film.makers.update.page.form.action.update.btn")
          }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>
<script>
import i18n from "@/i18n";
import TextEditor from "@/components/TextEditor";
import SingleFileUploader from "@/components/media/SingleFileUploader";
import { mapGetters, mapState  } from "vuex";
import { buildHeaders } from "@/api/_manager";
import DEFINES from "@/defines";
import rules from "@/validation";
export default {
  name: "FilmMakerUpdate",
  components: {
    TextEditor,
    SingleFileUploader,
  },
  data() {
    return {
      rules,
      currentTab: "profile",
      tabs: [
        {
          text: i18n.t("company.page.tab.profile"),
          route_name: "film.maker.profile",
          href: "#profile",
        },
      ],
      filmMaker: null,
      loading: false,
      showDropzoneLogoDialog: false,
      widget_language:null,
      languages: DEFINES.LOCALES,
    };
  },

  created() {
    this.fetchFilMaker();
  },

  computed: {
    ...mapGetters("company", {
      selected_company_id: "getSelected",
    }),
    ...mapState({
      company: (state) => state.company.company,
    }),
    enabledLanguages() {
        if (this.company) {
            return ('enabled_language_support' in this.company.custom_properties) ? this.company.custom_properties.enabled_language_support : this.i18n_locale; 
        }else{
            return this.i18n_locale
        }
    }
  },
  methods: {
    async fetchFilMaker() {
      await this.$store
        .dispatch("filmMaker/get", {
          id: this.$route.params.filmMakerId,
        })
        .then((response) => {
          this.filmMaker = response;
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: this.DEFINES.SNACKBAR_ERROR_COLOR,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    dropzoneOptions(uploading_relative_path) {
      return {
        acceptedFiles: "image/*",
        url: `${this.DEFINES.BASE_API_URL}/member/company/${this.selected_company_id}/${uploading_relative_path}`,
        thumbnailWidth: 200,
        maxFilesize: 1, //MB
        chunking: true,
        chunkSize: 2000000, // Bytes
        destroyDropzone: false,
        headers: buildHeaders().headers,
      };
    },
    afterThumbnailUpload(response) {
      if (response.data.file_id) {
        this.filmMaker.profile_picture = response.data.file_id;
      }
    },
    setThumbnail(event) {
      this.filmMaker.profile_url = event.value;
    },
    async showError(event) {
      try {
        await this.$store.dispatch("app/showMessage", {
          message: event.message,
          color: "error",
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },

    async save() {
      if (!this.$refs.form.validate()) {
        return false;
      }
        await this.$store.dispatch("filmMaker/update",this.filmMaker)
        .then((response) => {
            this.$store.dispatch("app/showMessage", {
                message: i18n.t("film.maker.action.update.success.message"),
                color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
            });
        })
       .catch ((error) => {
            this.$store.dispatch("app/showMessage", {
                message: error.message,
                color: "error",
            });
       })

    },
    setFieldLanguageData(fields, stateObject) {
      let __this = this
      fields.forEach(field => {
        __this.enabledLanguages.forEach((lang) => {
          if (lang.value !== 'en') {
            stateObject[field][lang.value] = stateObject[field]['en']
          }
        });
      });
    }
  },
};
</script>
